import { locHtml } from "./locHtml";
import { makeSplashHeader } from "./SplashHeader";


const shameSplashHtml = locHtml((t) => `
<div class="new-quote-container centered"> 
  <div class="splash-icon">🤝</div>
  <div class="splash-header">
    <h1>${t("splash.shame.title")}</h1>
    <div class="quote">
      ${t("splash.shame.text")}
    </div>
  </div>
</div>`);

const ShameSplashHeader = makeSplashHeader("splash.headers.shame");

const shameSplashElement = {
  visibleIf: `{shame} != "Rarely / Never"`,
  name: 'shame-splash',
  type: 'html',
  html: shameSplashHtml,
};

export {
  shameSplashElement,
  ShameSplashHeader,
};